import { post } from '@/service/request';
// import { requestOptions as options } from '@/service/requestOptions';

const url = 'api/endorse';
// const options = { errorDialog: true, secure: false, baseURL: true, repeatRequestCancel: false };

/** 條款同意 */
export function postAgreeEndorse() {
    return post(`${url}/agree`);
};
